module.exports = __webpack_public_path__ + "static/img/qm06_bg.3d198fb1.png";